module.exports = __webpack_public_path__ + "img/2.3eaec27f.svg";